export default "__VITE_ASSET__DNp5T9jU__"